import styled, { css, StyledComponent } from 'styled-components';

const colors = {
  primary: {
    black: '#1f1f1f',
    green: '#52c41a',
    blue: '#0046FF',
    orange: '#FA8C16',
    red: '#F5222D',
    teal: '#08979C',
    gray: '#BFBFBF',
  },
  light: {
    black: '#F0F0F0',
    green: '#F6FFED',
    blue: '#F2F6FF',
    orange: '#FFF7E6',
    red: '#FFF1F0',
    teal: '#E6FFFB',
    gray: '#F5F5F5',
  },
};

interface IStatusTag {
  size?: 'small' | 'large';
  type?: 'primary' | 'light' | 'ghost';
  typeColor?: 'black' | 'green' | 'blue' | 'orange' | 'red' | 'teal' | 'gray';
}

const StatusTag: StyledComponent<'span', any, IStatusTag, never> = styled.span<IStatusTag>`
  & {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 3px 4px;
    border-radius: 3px;
    font-size: 12px;
    letter-spacing: -0.11px;
    line-height: normal;

    &:not(:last-child) {
      margin-right: 2px;
    }

    ${({ size }) => {
      if (size === 'large') {
        return css`
          font-weight: 500;
          padding: 4px 8px;
          font-size: 14px;
          line-height: 1.5;
          border-radius: 4px;
        `;
      }
      return;
    }}

    ${({ type, typeColor }) => {
      if (type && typeColor) {
        const borderColor = type === 'ghost' ? colors.primary[typeColor] : colors[type][typeColor];
        const bgColor = type === 'ghost' ? 'transparent' : colors[type][typeColor];
        const textColor =
          type === 'primary'
            ? '#fff'
            : typeColor === 'gray'
            ? 'rgba(0,0,0,0.45)'
            : colors.primary[typeColor];
        return css`
          border: 1px solid ${borderColor};
          background: ${bgColor};
          color: ${textColor};
        `;
      }
      return;
    }}
  }
`;

export default StatusTag;
